// Mixins
import { dateMixins } from "@/app/mixins/utils/date-mixins";
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";
import { userMixins } from "@/app/mixins/modules/user-mixins.js";

// Service
import UserService from "@/app/services/main/user/user-service";
import PetOrderService from "@/app/services/main/pet-order/pet-order-service";

// Constants
import { STATES } from "@/app/constants/state-constants.js";
import { STATUS_CODES } from "@/app/constants/status-constants";

export default {
  name: "PuppyPurchaseStatus",
  components: {},
  directive: {},
  filters: {},
  mixins: [dateMixins, toastMessageMixins, userMixins],
  props: {
    puppyPurchaseDetails: {
      required: true,
      default: null,
    },
    successTitle: {
      type: String,
      default: "Congratulations, your purchase has been approved!",
    },
    subTitle: {
      type: String,
      default: "",
    },
    
  },
  data() {
    return {
      isAPILoading: false,
      havePetId: this.puppyPurchaseDetails
        ? !!this.puppyPurchaseDetails.puppyDetails.petId
        : false,
    };
  },
  computed: {
    showInformationSteps() {
      this.havePetId = this.puppyPurchaseDetails
        ? !!this.puppyPurchaseDetails.puppyDetails.petId
        : false;
    },
    isNativeApp() {
      return this.$store.getters.getIsNativeApp;
    },
    isUserLoggedIn() {
      return !!this.$store.getters.getUserToken;
    },
    isBuyerSameWithLoggedInUser(){
      if(!this.$store.getters.getUserToken && this.puppyPurchaseDetails){
        return;
      }

      const { customerDetails } = this.puppyPurchaseDetails;
      const { id: loggedInUser } = this.$store.getters.getUserDetails;

      return (customerDetails && customerDetails.userId) === loggedInUser;
    },
  },
  watch: {},
  methods: {
    showEmail(email) {
      if (email) {
        window.location.href = `mailto:${email}`;
      }
    },
    addPetToList() {
      const dogPurchaseDetails = {
        referenceNumber: this.$route.query.referenceId,
        token: "puppyPurchase",
      };

      PetOrderService.addDogPurchasePet(dogPurchaseDetails)
        .then((res) => {
          if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
            this.havePetId = true;

            this.showCustomSuccessToast(
              null,
              `Successfully added ${this.puppyPurchaseDetails.puppyDetails.breedName} as one of your pets.`
            );

            this.getUserDetailsAPIThenSwitchPet();
            this.$forceUpdate();
          } else {
            this.showAPIErrorToast("Unable to add pet to profile.", res);
          }
        })
        .catch(() => {
          this.showGenericErrorToast();
        })
        .finally(() => {
          this.isAPILoading = false;
        });
    },
    getUserDetailsAPIThenSwitchPet() {
      const { emailAddress } = this.getUserDetails();

      // lmdc get logged in user api
      UserService.getLoggedInUser(emailAddress).then((res) => {
        if (res.status === STATUS_CODES.SUCCESS) {
          this.$store.commit("setUserDetails", res.data.userDetails);

          // switch pet
          this.$store.commit(
            "setActivePet",
            this.getUserPets[this.getUserPets.length - 1]
          );
          EventBus.$emit("petSwitched");
        } else {
          this.showGenericErrorToast();
        }
      });
    },
    createAccount() {
      const referenceId = this.$route.query.referenceId;
      this.isAPILoading = true;
      let type = "puppyPurchase";
      UserService.postCreateUser({ referenceId, type })
        .then((res) => {
          if (res.status === STATUS_CODES.SUCCESS) {
            this.$swal({
              imageHeight: "30px",
              imageUrl: `${require("@/assets/images/_shared/success-dog.png")}`,
              imageAlt: "Success Dog",
              title: "Awesome!",
              text: "Please check your email for verification.",
              confirmButtonColor: "#4B8BFF",
              confirmButtonText: "Got it",
            });
          } else {
            this.showAPIErrorToast("Unable to create an account.", res);
          }
        })
        .catch((err) => {
          this.showAPIErrorToast("Unable to create an account.", err);
        })
        .finally(() => {
          this.isAPILoading = false;
        });
    },
    contactUsEmail() {
      window.location.href = "mailto:services@lovemydogclub.com.au";
    },
    mobileNumberFormat(mobileNumber) {
      if (mobileNumber) {
        let data = mobileNumber.split("");
        data.splice(4, 0, "-");
        return data.join("");
      } else {
        return "";
      }
    },
    stateName(state) {
      return state ? STATES[state] : "";
    },
    totalPriceValue(details) {
      return parseFloat(details.price) + parseFloat(details.storeCredit);
    },
  },
};
